import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'
import {ILeagueList} from './getLeagueList'

export const getLeagueDetail = async (id: string): Promise<ApiRes<ILeagueList>> => {
    return await apiGet(API_URL, `admin/league/${id}`)
}
